var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-link",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('div',{class:`button-icon button-icon-${_vm.icon}`}):_vm._e(),_c('div',{staticClass:"button-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }